<template>
  <div class="addExamination">
    <router-view v-if="showrouter" />
    <div
      v-else
      style="width:100%;height:100%;     padding: 1% 3% 0 2% ;position: relative ;  text-align: left"
    >
      <div style="width:100%;height:100%" v-if="!LabelisShowSlide">
        <div class="nameDiv">
          <div>
            <span>{{
              this.$route.query.examinationType == '0'
                ? $t('translateText.newwork.ksmc')
                : $t('translateText.newwork.zymc')
            }}</span>
            <input
              type="text"
              :placeholder="$t('translateText.newwork.srnr')"
              v-model="topic"
              style="color:#5f5f5f"
            />
          </div>
          <div class="searchh">
            <!-- <input type="text" placeholder="输入内容"/> -->
            <search :placeholder="$t('translateText.newwork.tmmc')" @search="onSearch" />
          </div>
        </div>
        <!-- <div>111</div> -->
        <div style="position: absolute;top: 60px;bottom: 60px;right: 2%;left: 2%">
          <div class="questionTypeDiv">
          <span>{{ $t('translateText.newwork.tmlx') }}：</span>
          <a-radio-group v-model="questionTypeValue" @change="getQuestions">
            <a-radio :value="1">{{
              $t('translateText.swi.dxt')
            }}</a-radio>
            <a-radio :value="2">{{
              $t('translateText.swi.ddxt')
            }}</a-radio>
            <a-radio :value="3">{{
              $t('translateText.swi.pdt')
            }}</a-radio>
            <a-radio :value="4">{{
              $t('translateText.swi.tkt')
            }}</a-radio>
            <a-radio :value="5">{{
              $t('translateText.swi.jdt')
            }}</a-radio>
            <a-radio :value="6">{{
              $t('translateText.swi.tjbz')
            }}</a-radio>
            <a-radio :value="7">{{
              $t('translateText.swi.jdbz')
            }}</a-radio>
          </a-radio-group>
        </div>
        <div class="questionLevelDiv">
          <span>{{ $t('translateText.newwork.ndxs') }}：</span>
          <a-radio-group v-model="questionLevelValue" @change="getQuestions">
            <a-radio :value="1">{{
              $t('translateText.newwork.jd')
            }}</a-radio>
            <a-radio :value="2">{{
              $t('translateText.newwork.yb')
            }}</a-radio>
            <a-radio :value="3">{{
              $t('translateText.newwork.kb')
            }}</a-radio>
          </a-radio-group>
        </div>
        <!-- <div style="position: absolute;top: 100px;right:0">
          
          <one-button v-on:translatecolor="addquestion">{{
            $t('translateText.newwork.xjst')
          }}</one-button>
        </div> -->
        <!-- <div class="checkAllBoxDiv">
                    <a-checkbox @change="checkAllChange">全选</a-checkbox>
                </div> -->
        <div class="questionListDiv" v-if="questionTypeValue == 1">
          <div
            v-for="question in singleQuestionAnswerList"
            :key="question.iQuestionId"
            v-show="singleQuestionAnswerList.length != 0"
          >
            <!-- <span>{{question.iScore}}</span> -->
            <single
              :questionInfo="question"
              :correctAnswerShow="false"
              v-on:allCheck="allCheck"
              @update="updatescore"
            ></single>
          </div>
        </div>
        <div class="questionListDiv" v-if="questionTypeValue == 2">
          <multiple
            v-for="question in multipleQuestionAnswerList"
            v-show="multipleQuestionAnswerList.length != 0"
            :questionInfo="question"
            :key="question.iQuestionId"
            :correctAnswerShow="false"
            v-on:allCheck="allCheck"
            @update="updatescore"
          ></multiple>
        </div>
        <div class="questionListDiv" v-if="questionTypeValue == 3">
          <judgment
            v-for="question in judgmentQuestionAnswerList"
            v-show="judgmentQuestionAnswerList.length != 0"
            :questionInfo="question"
            :key="question.iQuestionId"
            :correctAnswerShow="false"
            v-on:allCheck="allCheck"
            @update="updatescore"
          ></judgment>
        </div>
        <div class="questionListDiv" v-if="questionTypeValue == 4">
          <fillBlank
            v-for="question in fillBlankQuestionAnswerList"
            v-show="fillBlankQuestionAnswerList.length != 0"
            :questionInfo="question"
            :key="question.iQuestionId"
            :correctAnswerShow="false"
            v-on:allCheck="allCheck"
            @update="updatescore"
          ></fillBlank>
        </div>
        <div class="questionListDiv" v-if="questionTypeValue == 5">
          <shortAnswer
            v-for="question in shortAnswerQuestionAnswerList"
            v-show="shortAnswerQuestionAnswerList.length != 0"
            :questionInfo="question"
            :key="question.iQuestionId"
            :correctAnswerShow="false"
            v-on:allCheck="allCheck"
            @update="updatescore"
          ></shortAnswer>
        </div>
        <div class="questionListDiv" v-if="questionTypeValue == 6">
          <experiment
            v-for="question in addLabelQuestionAnswerList"
            :questionInfo="question"
            :key="question.iQuestionId"
            :correctAnswerShow="false"
            v-on:allCheck="allCheck"
            @update="updatescore"
            @showSlide="showSlide"
          ></experiment>
        </div>
        <div class="questionListDiv" v-if="questionTypeValue == 7">
          <experiment
            v-for="question in answerLabelQuestionAnswerList"
            :questionInfo="question"
            :key="question.iQuestionId"
            :correctAnswerShow="false"
            v-on:allCheck="allCheck"
            @update="updatescore"
          ></experiment>
        </div>

        </div>
        
        <div style="position: absolute;top: 100px;right:0">
          <one-button @click="preview"> {{$t('translateText.newwork.yl')}}</one-button>
          <one-button v-on:translatecolor="addquestion">{{
            $t('translateText.newwork.xjst')
          }}</one-button>
        </div>
        <!-- <div class="checkAllBoxDiv">
                    <a-checkbox @change="checkAllChange">全选</a-checkbox>
                </div> -->
        
        <div v-if="this.questionList.length == 0">
          <img src="@/assets/imgs/zanwusj.png" class="notdata" />
          <p class="notdatas">{{
            $t('translateText.noData')
          }}</p>
        </div>
        <div class="btnDiv">
          <one-button v-on:translatecolor="back">{{
            $t('translateText.swi.back')
          }}</one-button>
          <one-button
            v-if="
              this.$route.path == '/courseContent/Resources/Work/NewWork' ||
                this.$route.path ==
                  '/courseContent/Resources/TestPaper/NewTestPaper'
            "
            @click="creatework"
            >{{
            $t('translateText.newwork.cj')
          }}</one-button
          >
          <one-button
            v-if="
              this.$route.path == '/courseContent/Resources/Work/UpdateWork' ||
                this.$route.path ==
                  '/courseContent/Resources/TestPaper/UpdateTestPaper'
            "
            @click="savework"
            >{{
            $t('translateText.newwork.bc')
          }}</one-button
          >
          <one-button
            v-if="
              this.$route.path == '/courseContent/Task/AddExamination' ||
                this.$route.path == '/courseContent/Exam/AddExamination'
            "
            @click="saveClick"
            >{{
            $t('translateText.newwork.xyb')
          }}</one-button
          >
          <!-- 发布作业 -->
          <a-modal
            :visible="selectUserDiv"
            :footer="null"
            width="680px"
            @cancel="handleCancel"
          >
            <div>
              <p class="addHomeWorkDivTitle">{{ $t('translateText.newwork.fbdx') }}</p>
              <selectUser
                :ClassListColumns="ClassListColumns"
                :ShowClass="true"
                :UserListColumns="UserListColumns"
                @getReceiveList="selectedUserList"
                :ShowUser="true"
                ref="selectuser"
              ></selectUser>
              <div class="addHomeWorkDivFooter">
                <button @click="cancelButton"> {{ $t('translateText.newwork.qx') }}</button>
                <button @click="okButton" class="okButton">{{ $t('translateText.newwork.fb') }}</button>
              </div>
            </div>
          </a-modal>
        </div>
      </div>
      <ShowSlide
        ref="labLabel"
        v-if="LabelisShowSlide"
        :slideId="slideArg.slideId"
        :userId="slideArg.userId"
        :otherUserId="slideArg.otherUserId"
        :opentions="opentions"
        :p="slideArg.p"
      />
    </div>
  </div>
</template>
<script>
const moment = require('moment')
import search from '@/components/search' //搜索组件
import selectUser from '@/components/Table/SelectUser' //选择发布用户
import single from '@/components/Question/Single' //单选题
import multiple from '@/components/Question/Multiple' //多选题
import judgment from '@/components/Question/Judgment' //判断题
import fillBlank from '@/components/Question/FillBlank' //填空题
import shortAnswer from '@/components/Question/ShortAnswer' //简答题
import experiment from '@/components/Question/Experiment' //实验标注题
import {
  getQuestions,
  addExamination,
  updateExamination,
  releaseExamination,
} from '@/utils/api'
import ShowSlide from '@/components/Question/LabQuestion'
import CryptoJS from 'crypto-js'
export default {
  data() {
    return {
      itiScore: '',
      questionInfo: '',
      grade: 0,
      updatelist: [], //修改分数的题目
      examinationinfo: [],
      topic: '',
      userinfo: {},
      courseid: '',
      questionTypeValue: 1,
      oldQuestionTypeValue: 1,
      questionLevelValue: 1,
      questionList: [],
      selectUserDiv: false,
      selectedtopic: [], //选中的题目
      selectQuestion: [], //选中的题目
      primary: [], //复制一份selectedtopic，用于计算删除的选题
      repetitive: [],
      reduced: [],
      delexamination: [],
      starttime: '', //开始时间
      endtime: '', //结束时间
      passingscore: '', //及格分数线
      goodscore: '', //良好分数线
      excellentscore: '', //优秀分数线
      stickup: '', //是否允许粘贴
      outorder: '', //是否乱序
      viewscore: '', //学生是否可查看成绩
      releaseobj: [], //发放对象
      releasetype: '',
      searchKey: '',
    //   ClassListColumns: [
    //     {
    //       title: '班级',
    //       dataIndex: 'strClassName',
    //     },
    //   ],
    //   UserListColumns: [
    //     {
    //       title: '学号',
    //       dataIndex: 'strUserName',
    //     },
    //     {
    //       title: '姓名',
    //       dataIndex: 'strRealName',
    //     },
    //   ],
      singleQuestionAnswerList: [],
      multipleQuestionAnswerList: [],
      judgmentQuestionAnswerList: [],
      fillBlankQuestionAnswerList: [],
      shortAnswerQuestionAnswerList: [],
      addLabelQuestionAnswerList: [],
      answerLabelQuestionAnswerList: [],
      LabelisShowSlide: false,
      slideArg: {
        //显示切片参数
        slideId: '',
        courseFileId: '',
        userId: '',
        otherUserId: '',
        p: '',
      },
      showrouter: false,
    }
  },
  mounted() {
    this.userinfo = this.$store.state.userinfo
    this.courseid = localStorage.getItem('courseId')
    this.getQuestions()
    if (
      this.$route.path == '/courseContent/Resources/Work/UpdateWork' ||
      this.$route.path == '/courseContent/Resources/TestPaper/UpdateTestPaper'
    ) {
      this.examinationinfo = this.$store.state.examinationinfo
      this.topic = this.examinationinfo.examination.strExaminationName
      this.primary = this.examinationinfo.listQuestion.map((item) => {
        return Object.assign(
          {},
          {
            iExamQuestionId: item.iExamQuestionId,
            question: { iQuestionId: item.question.iQuestionId },
            iScore: item.iScore,
          }
        )
      })
      this.reduced = JSON.parse(JSON.stringify(this.primary))
      this.selectedtopic = this.examinationinfo.listQuestion.map((item) => {
        return Object.assign(
          {},
          {
            iExamQuestionId: item.iExamQuestionId,
            question: item.question ,
            iScore: item.iScore,
          }
        )
      })
      // this.primary = this.selectedtopic
    }
  },
  methods: {
    //新建试题
    addquestion() {
      if (
        this.$route.path == '/courseContent/Resources/Work/NewWork' ||
        this.$route.path == '/courseContent/Resources/Work/UpdateWork'
      ) {
        this.$router.push('/courseContent/Resources/Work/NewWork/NewQuestion')
      }
      if (
        this.$route.path == '/courseContent/Resources/TestPaper/NewTestPaper' ||
        this.$route.path == '/courseContent/Resources/TestPaper/UpdateTestPaper'
      ) {
        this.$router.push(
          '/courseContent/Resources/TestPaper/NewTestPaper/NewQuestion'
        )
      }
      if (this.$route.path == '/courseContent/Task/AddExamination') {
        this.$router.push('/courseContent/Task/AddExamination/NewQuestion')
      }
      if (this.$route.path == '/courseContent/Exam/AddExamination') {
        this.$router.push('/courseContent/Exam/AddExamination/NewQuestion')
      }
      this.showrouter = true
      this.$store.commit('updataeffect', 'add')
    },
    //浏览实验标注题
    showSlide(questionInfo) {
      let permissions = [1, 2]
      permissions = CryptoJS.enc.Utf8.parse(JSON.stringify(permissions))
      let cryptPwd = CryptoJS.AES.encrypt(
        permissions,
        CryptoJS.enc.Utf8.parse('12345678123456781234567812345678'),
        {
          mode: CryptoJS.mode.ECB,
        }
      ).toString()
      cryptPwd = encodeURIComponent(cryptPwd)
      this.LabelisShowSlide = true
      this.slideArg.slideId = questionInfo.courseData.iCourseDataId
      this.slideArg.courseFileId = 0
      this.slideArg.userId = this.userinfo.iUserId
      this.slideArg.otherUserId = 0
      this.slideArg.p = cryptPwd
      this.opentions = JSON.parse(questionInfo.strQuestionInfo).question
    },
    //更新分数
    updatescore(val) {
      // if( this.$route.path =='/courseContent/Resources/Work/NewWork'){
      this.selectedtopic = this.selectedtopic.map((item) =>
        item.question.iQuestionId === val.question.iQuestionId ? val : item
      )
    },
    onSearch(val) {
      //搜索按钮的回调事件
      // this.searchuser(val);
      this.questionInfo = val
      this.getQuestions()
    },
    getQuestions() {
      getQuestions({
        iCourseId: this.courseid,
        iQuestionType: this.questionTypeValue,
        iQuestionLevel: this.questionLevelValue,
        strQuestionInfo: this.questionInfo,
      }).then((response) => {
        if (response.data.iCode == 0) {
          switch (this.questionTypeValue) {
            case 1:
              this.singleQuestionAnswerList = response.data.objData
              break
            case 2:
              this.multipleQuestionAnswerList = response.data.objData
              break
            case 3:
              this.judgmentQuestionAnswerList = response.data.objData
              break
            case 4:
              this.fillBlankQuestionAnswerList = response.data.objData
              break
            case 5:
              this.shortAnswerQuestionAnswerList = response.data.objData
              break
            case 6:
              this.addLabelQuestionAnswerList = response.data.objData
              break
            case 7:
              this.answerLabelQuestionAnswerList = response.data.objData
              break
          }
          this.questionList = response.data.objData
        } else {
          return this.$message.error(response.data.strMessage)
        }
      })
    },
    allCheck(val) {
        console.log(val);
      var a = -1
      this.selectedtopic.map((item, index) => {
        if (item.question.iQuestionId == val.question.iQuestionId) {
          a = index
        }
      })
      if (a == -1) {
        this.selectedtopic.push(val)
      } else {
        this.selectedtopic.splice(a, 1)
      }

    },
    back() {
      this.$router.go(-1)
    },
    //创建完成
    creatework() {
      this.grade = 0
      this.itiScore = 1
      this.selectedtopic.map((item) => {
        this.grade += parseInt(item.iScore)
        if (item.iScore == 0) {
          this.itiScore = item.iScore
        }
      })
      if (this.topic == '' || this.topic.split(' ').join('').length == 0) {
        return this.$message.error(this.$t('translateText.newwork.mcbwk'))
      } else if (this.grade > 100) {
        this.grade = 0
        return this.$message.error(this.$t('translateText.newwork.fsdy'))
      } else if (this.selectedtopic.length == 0) {
        return this.$message.error(this.$t('translateText.newwork.zytmbwk'))
      } else if (this.itiScore == 0) {
        return this.$message.error(this.$t('translateText.newwork.cztmw'))
      } else {
        addExamination({
          examination: {
            user: {
              iUserId: this.userinfo.iUserId,
            },
            course: {
              iCourseId: this.courseid,
            },
            strExaminationName: this.topic,
            ddExaminationType: {
              iNumber: this.$route.query.examinationType,
            },
          },
          listExaminationQuestion: this.selectedtopic,
        }).then((response) => {
          if (response.data.iCode == 0) {
            // this.getQuestions()
            this.grade = 0
            this.$parent.searchKey = ''
            this.$parent.getexamination()
            this.$router.go(-1)
            return this.$message.success(this.$t('translateText.newwork.cjgc'))
          } else if(this.$route.query.examinationType == '0' && response.data.iCode == 1000){
            return this.$message.error(this.$t('translateText.newwork.sjmcz'))
          }else if(this.$route.query.examinationType == '1' && response.data.iCode == 1000){
            return this.$message.error(this.$t('translateText.newwork.zymcz'))
          } else {
            return this.$message.error(response.data.strMessage)
          }
        })
      }
    },
    createtest() {
      this.$router.go(-1)
      //return this.$message.success(`该试卷创建成功`);
    },
    //修改完成保存
    savework() {
      this.itiScore = 1
      this.grade = 0
      this.selectedtopic.map((item) => {
        this.grade += parseInt(item.iScore)
        if (item.iScore == 0) {
          this.itiScore = item.iScore
        }
      })
      for (let i = 0; i < this.primary.length; i++) {
        for (let j = 0; j < this.selectedtopic.length; j++) {
          if (
            this.primary[i].question.iQuestionId ==
            this.selectedtopic[j].question.iQuestionId
          ) {
            this.repetitive.push(this.primary[i])
            // if(this.selectedtopic[j].iExamQuestionId == undefined){
            //     this.selectedtopic.splice(j,1)
            // }
          }
        }
      }
      console.log(this.primary)
      console.log(this.repetitive)
      console.log(this.selectedtopic)
      this.reduced = this.primary.filter(
        (item) => !this.repetitive.includes(item)
      )
      if (this.topic == '' || this.topic.split(' ').join('').length == 0) {
        return this.$message.error(this.$t('translateText.newwork.mcbwk'))
      } else if (this.grade > 100) {
        this.grade = 0
        return this.$message.error(this.$t('translateText.newwork.fsdy'))
      } else if (this.selectedtopic.length == 0) {
        return this.$message.error(this.$t('translateText.newwork.zytmbwk'))
      } else if (this.itiScore == 0) {
        return this.$message.error(this.$t('translateText.newwork.cztmw'))
      } else {
        updateExamination({
          iExaminationId: this.examinationinfo.examination.iExaminationId,
          strExaminationName: this.topic,
          listExaminationQuestion: this.selectedtopic,
          listDelExaminationQuestion: this.reduced,
        }).then((response) => {
          if (response.data.iCode == 0) {
            this.$parent.data.map((item) => {
              if (
                item.iExaminationId ==
                this.examinationinfo.examination.iExaminationId
              ) {
                item.strExaminationName = this.topic
              }
            })
            this.$router.go(-1)
            this.$parent.getexamination()
            return this.$message.success(this.$t('translateText.newwork.xgcg'))
          } else {
            return this.$message.error(response.data.strMessage)
          }
        })
      }
      //return this.$message.success(`该作业编辑完成`);
    },
    saveClick() {
      this.grade = 0
      this.itiScore = 1
      this.selectedtopic.map((item) => {
        if (item.iScore == 0) {
          this.itiScore = item.iScore
        }
        this.grade += parseInt(item.iScore)
      })
      if (this.$route.query.examinationType == '1') {
        if (this.grade > 100) {
          this.grade = 0
          return this.$message.error(this.$t('translateText.newwork.fsdy'))
        }
        if (this.selectedtopic.length == 0) {
          return this.$message.error(this.$t('translateText.newwork.zytmbwk'))
        }
        if (this.topic == '') {
          return this.$message.error(this.$t('translateText.newwork.zymcbwk'))
        }
        if (this.itiScore == 0) {
          return this.$message.error(this.$t('translateText.newwork.cztmw'))
        }
      } else {
        if (this.grade > 100) {
          this.grade = 0
          return this.$message.error(this.$t('translateText.newwork.fsdy'))
        }
        if (this.selectedtopic.length == 0) {
          return this.$message.error(this.$t('translateText.newwork.kstmbwk'))
        }
        if (this.topic == '') {
          return this.$message.error(this.$t('translateText.newwork.ksmcbwk'))
        }
        if (this.itiScore == 0) {
          return this.$message.error(this.$t('translateText.newwork.cztmfs'))
        }
      }
      this.selectUserDiv = true
    },
    savetest() {
      this.$router.go(-1)
      //return this.$message.success(`该试卷编辑完成`);
    },
    cancelButton() {
      this.selectUserDiv = false
      this.selectUserBtn = false
    },
    okButton() {
      (this.starttime = this.$refs.selectuser.startValue), //开始时间
        (this.endtime = this.$refs.selectuser.endValue), //结束时间
        (this.passingscore = this.$refs.selectuser.passingScore), //及格分数线
        (this.goodscore = this.$refs.selectuser.goodScore), //良好分数线
        (this.excellentscore = this.$refs.selectuser.excellentScore), //优秀分数线
        (this.stickup = this.$refs.selectuser.isStickUp ? 1 : 0), //是否允许粘贴
        (this.outorder = this.$refs.selectuser.isOutOrder ? 1 : 0), //是否乱序
        (this.viewscore = this.$refs.selectuser.isViewScore ? 1 : 0) //学生是否可看成绩
      // this.release = this.$refs.selectuser.showClassList
      if (this.releaseobj.length == 0) {
        return this.$message.error(this.$t('translateText.newwork.xzfb'))
      }
      if (this.starttime == null || this.endtime == null) {
        return this.$message.error(this.$t('translateText.newwork.zdsj'))
      }
      addExamination({
        examination: {
          user: {
            iUserId: this.userinfo.iUserId,
          },
          course: {
            iCourseId: this.courseid,
          },
          strExaminationName: this.topic,
          ddExaminationType: {
            iNumber: this.$route.query.examinationType,
          },
        },
        listExaminationQuestion: this.selectedtopic,
      }).then((response) => {
        if (response.data.iCode == 0) {
          if (this.releasetype == 0) {
            releaseExamination({
              dtStartTime: moment(this.starttime).format('YYYY-MM-DD HH:mm:ss'),
              dtEndTime: moment(this.endtime).format('YYYY-MM-DD HH:mm:ss'),
              iPassingScore: this.passingscore,
              iGoodScore: this.goodscore,
              iExcellentScore: this.excellentscore,
              isStickUp: this.stickup,
              isOutOrder: this.outorder,
              isViewScore: this.viewscore,
              iExamReleaseType: this.releasetype,
              listExamination: [
                {
                  iExaminationId: response.data.objData.iExaminationId,
                },
              ],
              listUserClass: this.releaseobj,
            }).then((response) => {
              if (response.data.iCode == 0) {
                this.$router.go(-1)
                this.$parent.searchKey = ''
                this.$parent.getdata()
                // this.getQuestions()
              } else {
                return this.$message.error(response.data.strMessage)
              }
            })
          }
          if (this.releasetype == 1) {
            releaseExamination({
              dtStartTime: moment(this.starttime).format('YYYY-MM-DD HH:mm:ss'),
              dtEndTime: moment(this.endtime).format('YYYY-MM-DD HH:mm:ss'),
              iPassingScore: this.passingscore,
              iGoodScore: this.goodscore,
              iExcellentScore: this.excellentscore,
              isStickUp: this.stickup,
              isOutOrder: this.outorder,
              isViewScore: this.viewscore,
              iExamReleaseType: this.releasetype,
              listExamination: [
                {
                  iExaminationId: response.data.objData.iExaminationId,
                },
              ],
              listUser: this.releaseobj,
            }).then((response) => {
              if (response.data.iCode == 0) {
                this.$router.go(-1)
                this.$parent.getdata()
              } else {
                return this.$message.error(response.data.strMessage)
              }
            })
          }
        } else if(this.$route.query.examinationType == '0' && response.data.iCode == 1000){
          return this.$message.error(this.$t('translateText.newwork.sjmcz'))
        }else if(this.$route.query.examinationType == '1' && response.data.iCode == 1000){
          return this.$message.error(this.$t('translateText.newwork.zymcz'))
        } else {
          return this.$message.error(response.data.strMessage)
        }
      })
      // this.$router.go(-1);
    },
    handleCancel() {
      this.selectUserDiv = false
      this.selectUserBtn = false
    },
    selectedUserList(val, type) {
      this.releasetype = type
      if (type == 0) {
        this.releaseobj = val.map((item) => {
          return Object.assign({}, { iClassId: item })
        })
      } else if (type == 1) {
        this.releaseobj = val.map((item) => {
          return Object.assign({}, { iUserId: item })
        })
      }
    },
    preview(){
      sessionStorage.setItem('AnswerList', JSON.stringify(this.selectedtopic))
      if (
        this.$route.path == '/courseContent/Resources/Work/NewWork'
      ) {
        this.$router.push('/courseContent/Resources/Work/NewWork/preview')
      }
      if (
        this.$route.path == '/courseContent/Resources/Work/UpdateWork'
      ) {
        this.$router.push('/courseContent/Resources/Work/UpdateWork/preview')
      }
      if (
        this.$route.path == '/courseContent/Resources/TestPaper/NewTestPaper' 
      ) {
        this.$router.push('/courseContent/Resources/TestPaper/NewTestPaper/preview')
      }
      if (
        this.$route.path == '/courseContent/Resources/TestPaper/UpdateTestPaper'
      ) {
        this.$router.push('/courseContent/Resources/TestPaper/UpdateTestPaper/preview')
      }
      if (this.$route.path == '/courseContent/Task/AddExamination') {
        this.$router.push('/courseContent/Task/AddExamination/preview')
      }
      if (this.$route.path == '/courseContent/Exam/AddExamination') {
        this.$router.push('/courseContent/Exam/AddExamination/preview')
      }
      this.showrouter = true
    }
  },
  components: {
    search,
    selectUser,
    single,
    multiple,
    judgment,
    fillBlank,
    shortAnswer,
    experiment,
    ShowSlide,
  },
  computed: {
    ClassListColumns() {
      return [
        {
          title: this.$t('translateText.newwork.bj'),
          dataIndex: 'strClassName',
        },
      ]
    },
    UserListColumns() {
      return [
        {
          title: this.$t('translateText.newwork.xh'),
          dataIndex: 'strUserName',
        },
        {
          title: this.$t('translateText.newwork.xm'),
          dataIndex: 'strRealName',
        },
      ]
    },
  },
  watch:{
    selectedtopic(val){
        console.log(val);
    }
  }
}
</script>
<style lang="stylus" scoped>
input
    outline: none
.addExamination
    height: 100%
    width: 100%
.checkAllBoxDiv
    position: absolute
    top: 60px
    line-height: 40px
    right: 10%
&/deep/.ant-checkbox-inner
    border: 2px solid #2EADB5
&/deep/.ant-checkbox-input:focus + .ant-checkbox-inner
    border-color: #2EADB5
&/deep/.ant-checkbox-checked .ant-checkbox-inner
    background-color: #2EADB5
    border-color: #2EADB5
.nameDiv, .questionTypeDiv, .questionLevelDiv
    color: #2EADB5
    line-height: 40px
.nameDiv
    width :100%
    display :flex
    line-height: 60px
    position: absolute
    top: 0

.nameDiv input
    width: 250px
    height: 36px
    border: 1px solid #505050
    border-radius: 4px
    padding: 5px
.searchh{
      width :20%
      position: absolute
      top:20%
      right: 10%
}
.nameDiv span, .questionTypeDiv span, .questionLevelDiv span
    margin-right: 5px
&/deep/.ant-radio-checked .ant-radio-inner
    border-color: #2EADB5
&/deep/.ant-radio-inner::after
    background-color: #2EADB5
.questionListDiv
    max-height:70%
    overflow: auto
.btnDiv
    position: absolute
    bottom: -5px
    right: 2%
    left: 2%
    height: 40px
    // text-align: center
    & button
        margin-left: 25%;
.addHomeWorkDivFooter
    text-align: center
    margin-top: 10px
.addHomeWorkDivFooter button
    margin: 0 20px
    padding: 5px 15px
    background-color: #fff
    border: solid 1px #7C838D
    border-radius: 3px
    color: #7C838D
.addHomeWorkDivFooter .okButton
    background-color: #2EADB5
    border: none
    color: #fff
.notdata{

  margin-top: 18%;
  margin-left: 36%;
  width :200px
}
.notdatas{
  margin-top :1%;
  margin-left: 43%;
  color :rgba(0, 0, 0, 0.35);
}
/deep/span.ant-radio + * {
    padding-right: 3px;
    padding-left: 3px;
}
</style>
